'use client'
import { useState, useEffect } from 'react';
import config from 'config/config';

 const useSubscriptionPlans = (defaultSubPlanType ) => {
     
  const [subplans, setSubplans] = useState([]);

  const fetchSubplans = async (type) => {
    try {
      const response = await fetch(config.endPointGetPricing, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ planType: type }),
      });
      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setSubplans(data);
    } catch (err) {
      console.error('Failed to fetch subscription plans:', err);
    }
  };

  useEffect(() => {
    fetchSubplans(defaultSubPlanType);
  }, []);

  const togglePlanType = (planType) => {
    fetchSubplans(planType);
  };

  return { subplans, togglePlanType };
};
export default useSubscriptionPlans